// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { formatText } = require('core/i18n').i18n;

// @commons
const OKTag = require('components/commons/OKTag/OKTag');

// @constants
const {
    DISABLED_PROBABILITY,
    HIGH_PROBABILITY,
    MEDIUM_PROBABILITY,
    LOW_PROBABILITY,
    NONE_PROBABILITY,
    RA_GOAL_REACHED,
    RA_GOAL_NOT_REACHED,
    SAVE_SIMULATION,
} = require('../../raConstants/index');

class RAProbabilityTag extends React.Component {
    render() {
        const { label } = this.props;
        const key = `raProbabilityTag-raProbabilityTag_${label}`;
        const contentTag = formatText(key);

        let type;
        let emphasis = false;
        switch (label) {
            case RA_GOAL_REACHED:
                type = 'success';
                emphasis = true;
                break;
            case RA_GOAL_NOT_REACHED:
                type = 'warning';
                break;
            case HIGH_PROBABILITY:
                type = 'success';
                break;
            case MEDIUM_PROBABILITY:
                type = 'pending';
                break;
            case LOW_PROBABILITY:
            case NONE_PROBABILITY:
                type = 'informative';
                break;
            case DISABLED_PROBABILITY:
                type = 'disabled';
            case SAVE_SIMULATION:
                type = 'pending';
                break;
        }

        return <OKTag content={contentTag} type={type} emphasis={emphasis} />;
    }
}

RAProbabilityTag.propTypes = {
    label: PropTypes.string.isRequired,
};

module.exports = RAProbabilityTag;
